import { render, staticRenderFns } from "./delete_dialog.vue?vue&type=template&id=2d0fd4c0&scoped=true&"
import script from "./delete_dialog.vue?vue&type=script&lang=js&"
export * from "./delete_dialog.vue?vue&type=script&lang=js&"
import style0 from "./delete_dialog.vue?vue&type=style&index=0&id=2d0fd4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0fd4c0",
  null
  
)

export default component.exports